import CustomButton from "@components/buttons/CustomButton";
import { useNavigate } from "react-router-dom";

const GenericError = () => {
  const navigate = useNavigate();

  return (
    <div className="h-[100dvh] ">
      <div className="bg-bg-button-secondary noise flex flex-grow justify-center ">
        <div className="flex flex-col items-center  justify-center px-8 ">
          <div className="w-full max-w-sm">
            <div className="text-center bg-white dark:bg-gray-800 mt-8 rounded-lg pb-3">
              <h1 className="text-lg px-4 py-3 rounded-t-lg justify-center items-center font-semibold mb-4 text-text-transactions-summary-base text-center">
                Uh-oh! An error occurred
              </h1>

              <div className="px-6 mb-4 text-sm text-[#15182C]">
                <p className="mb-4">ACCESS DENIED.</p>

                <CustomButton
                  text="RETRY LOGIN"
                  onClick={() => navigate("/login")}
                  isActive={true}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GenericError;
